import intermind from '../../../index';
import { ListConfig, ListParams, ListResponse } from '../../../types';
import { Invoice } from '../types/invoice.types';

export class InvoiceResource {
  async listConfig(): Promise<ListConfig> {
    const { data } = await intermind.httpClient.get<ListConfig>('/billing/invoices/list-config');
    return data;
  }

  async list(params: ListParams): Promise<ListResponse<Invoice>> {
    const { data } = await intermind.httpClient.get<ListResponse<Invoice>>('/billing/invoices', {
      params,
    });
    return data;
  }
}
